module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/chad/Developer/shelfmaid-abel/site/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0